














    import Vue from 'Vue';
    import Vuex from 'Vuex';
    import speedDialItem from './speedDialItem.vue'
    export default Vue.extend({
        name: 'c-speed-dial',
        components: { speedDialItem },
        data() {
            return { visible:false};
        },
        computed: {
            haveItems(): boolean { return this.$store.state.ui.speedDialItems != null && this.$store.state.ui.speedDialItems.length > 0; },
            btnAriaLabelClose(): string { return this.$vuetify.lang.t('webmap.ariaLabels.close'); },
            btnAriaLabelView(): string { return this.$vuetify.lang.t('webmap.ariaLabels.view'); },
            btnTooltipClose(): string { return this.$vuetify.lang.t('webmap.tooltips.close'); },
            btnTooltipView(): string { return this.$vuetify.lang.t('webmap.tooltips.view'); }
        }
    });
